export const POC_DETAILS = "pocDetails"
export const NAME = "schoolName";
export const PHONE = "phoneNo";
export const EMAIL = "email";
export const DESIGNATION = "designation";

// Infrastructure Items
export const INCLUDES_TV = "includes_tv";
export const INCLUDES_3D_PRINTER = "includes_3d_printer";
export const INCLUDES_PAINTING = "includes_painting";
export const INCLUDES_ELECTRICAL = "includes_electrical";
export const INCLUDES_STORAGE_CABINETS = "includes_storage_cabinets";
export const INCLUDES_TEACHERS_TABLE = "includes_teachers_table";
export const INCLUDES_PODIUM_MIC = "includes_podium_mic";
export const INCLUDES_TABLETS = "includes_tablets";
export const INCLUDES_CHAIRS = "includes_chairs";

// Notes
export const INFRASTRUCTURE_NOTES = "infrastructure_notes";
export const CURRICULUM_NOTES = "curriculum_notes";
export const OTHER_NOTES = "other_notes";



export const tabs = [
  { title: "Resource Management", value: "1" },
  { title: "Task Management", value: "2" },
];